/* 1000 причини - theme scripts */
(function () {
  'use strict';
  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------- Reasons: pinned, scroll-driven ----------
     The whole sequence is a function of how far the page has scrolled through the section, so it
     behaves the same with mouse, trackpad, touch, keyboard or scrollbar, wherever the pointer is.
     u = screens scrolled since the section pinned.  0..B: book opens · B..B+R: ring opens into the drum ·
     then one card every C screens (each card eases in and holds front-and-centre). */
  function Wheel(root) {
    var stage = root.querySelector('[data-ww-stage]');
    var wheel = root.querySelector('[data-ww-wheel]');
    var burst = root.querySelector('[data-ww-burst]');
    var label = root.querySelector('[data-ww-label]');
    var labelIn = root.querySelector('[data-ww-label-in]');
    var book = root.querySelector('[data-ww-book]');
    var bk = root.querySelector('[data-bk]'), bkFront = root.querySelector('[data-bk-front]');
    var leaf1 = root.querySelector('[data-bk-leaf1]'), leaf2 = root.querySelector('[data-bk-leaf2]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ww-card]'));
    var index = Array.prototype.slice.call(root.querySelectorAll('[data-ww-pick]'));
    var counter = root.querySelector('[data-ww-counter]');
    var prog = root.querySelector('[data-ww-prog]');
    var n = cards.length;
    if (!stage || !wheel || !n) return;
    var hasBook = root.getAttribute('data-book') === '1' && !!book;
    var cardScroll = (parseInt(root.getAttribute('data-card-scroll'), 10) || 55) / 100;
    var last = n - 1, turn = 0, target = 0, m = null, active = -1, open = null, H = 0;
    var pad = function (k) { return (k < 10 ? '0' : '') + k; };
    var cl = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
    var ss = function (a, b, x) { var t = cl((x - a) / (b - a)); return t * t * (3 - 2 * t); };

    function geom() {
      var narrow = window.innerWidth < 900;
      var B = hasBook ? 0.8 : 0.15, R = 0.5, C = cardScroll * (narrow ? 0.8 : 1), T = 0.35;
      return { B: B, R: R, C: C, H: 1 + B + R + last * C + T };
    }

    function measure() {
      var w = stage.clientWidth, h = stage.clientHeight;
      if (!h) return;
      var narrow = w < 720;
      var cardW = Math.min(h * (narrow ? 0.5 : 0.44) * 1.45, w * (narrow ? 0.86 : 0.36));
      var cardH = cardW / 1.45;
      var ringR = cardH * (narrow ? 1.2 : 1.1);
      var ringScale = Math.min(1, Math.max(0.16, ((2 * Math.PI * ringR / n) * 0.82) / cardW));
      m = { cardW: cardW, cardH: cardH, ringR: ringR, ringScale: ringScale, drumR: cardH * 2.22, bow: cardH * 1.82 };
      stage.style.perspective = (cardH * 2.7) + 'px';
      cards.forEach(function (c) {
        c.style.width = cardW + 'px'; c.style.height = cardH + 'px';
        c.style.marginLeft = (-cardW / 2) + 'px'; c.style.marginTop = (-cardH / 2) + 'px';
      });
    }

    function update() {
      if (window.innerWidth < 900) return; /* phones use the swipe carousel instead (ReasonsMobile) */
      var G = geom();
      if (G.H !== H) { H = G.H; root.style.setProperty('--ww-h', String(H)); }
      var vh = window.innerHeight, r = root.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var span = r.height - vh, p = span > 0 ? cl(-r.top / span) : 0;
      var u = reduced ? G.B + G.R : p * (G.H - 1);
      var b = cl(u / G.B);
      if (hasBook) {
        var tilt = ss(0, 0.35, b);
        bk.style.transform = 'rotateX(' + (10 * (1 - tilt)) + 'deg) rotateY(' + (-22 * (1 - tilt)) + 'deg) translateX(' + (28 * ss(0.15, 0.6, b)) + '%)';
        bkFront.style.transform = 'translateZ(4px) rotateY(' + (-168 * ss(0.1, 0.6, b)) + 'deg)';
        leaf1.style.transform = 'translateZ(3px) rotateY(' + (-150 * ss(0.2, 0.65, b)) + 'deg)';
        leaf2.style.transform = 'translateZ(3px) rotateY(' + (-128 * ss(0.25, 0.7, b)) + 'deg)';
        book.style.transform = 'scale(' + (1 + 0.45 * ss(0.6, 1, b)) + ')';
        book.style.opacity = String(1 - ss(0.65, 0.95, b));
        book.style.visibility = b >= 0.98 ? 'hidden' : 'visible';
        burst.style.transform = 'scale(' + (0.12 + 0.88 * ss(0.55, 0.95, b)) + ')';
        burst.style.opacity = String(ss(0.55, 0.85, b));
        if (labelIn) labelIn.style.opacity = String(ss(0.85, 1, b));
      }
      if (u < G.B) target = 0;
      else if (u < G.B + G.R) target = (u - G.B) / G.R;
      else {
        var x = Math.min(last, (u - G.B - G.R) / G.C), k = Math.floor(x), f = x - k;
        target = 1 + k + ss(0.25, 0.75, f);
      }
      if (prog) prog.style.transform = 'scaleX(' + p + ')';
      kick();
    }

    // Buttons and the list scroll the page to that card, so scroll position stays the single source of truth.
    function scrollToCard(i) {
      var G = geom(), vh = window.innerHeight, r = root.getBoundingClientRect();
      var k = Math.max(0, Math.min(last, i));
      var want = ((G.B + G.R + k * G.C) / (G.H - 1)) * (r.height - vh);
      var delta = want + r.top;
      try { window.scrollBy({ top: delta, behavior: reduced ? 'auto' : 'smooth' }); } catch (e) { window.scrollBy(0, delta); }
    }

    var running = false;
    function kick() { if (!running) { running = true; requestAnimationFrame(draw); } }
    function draw() {
      if (!m) { measure(); if (!m) { running = false; return; } }
      var gap = target - turn;
      if (Math.abs(gap) < 0.0005 || fx.touch || reduced) { turn = target; running = false; }
      else { turn += gap * 0.25; requestAnimationFrame(draw); }
      var mm = cl(turn), pos = Math.max(0, turn - 1);
      wheel.style.transform = 'translateZ(' + (-mm * m.drumR) + 'px)';
      for (var i = 0; i < n; i++) {
        var d = i - pos, drumDeg = d * 40, ringDeg = d * (360 / n);
        var bowX = -m.bow * (1 - Math.cos(drumDeg * Math.PI / 180));
        var c = cards[i];
        c.style.transform = 'translateX(' + (mm * bowX) + 'px) rotateZ(' + ((1 - mm) * ringDeg) + 'deg) translateY(' + (-(1 - mm) * m.ringR) + 'px) rotateX(' + (mm * drumDeg) + 'deg) translateZ(' + (mm * m.drumR) + 'px)';
        c.style.opacity = (mm > 0.5 && Math.abs(d) > 1.6) ? '0' : '1';
        c.style.zIndex = String(Math.round(100 - Math.abs(d) * 2));
        var face = c.firstElementChild;
        if (face) face.style.transform = 'scale(' + (m.ringScale + (1 - m.ringScale) * mm) + ')';
      }
      if (label) label.style.opacity = String(1 - mm);
      var near = Math.max(0, Math.min(last, Math.round(pos))), isOpen = turn > 0.5;
      if (near !== active || isOpen !== open) {
        active = near; open = isOpen;
        index.forEach(function (b, k) { b.classList.toggle('is-active', open && k === active); });
        if (counter) counter.textContent = (open ? pad(active + 1) : '00') + ' / ' + pad(n);
      }
    }

    var prev = root.querySelector('[data-ww-prev]'), next = root.querySelector('[data-ww-next]');
    if (prev) prev.addEventListener('click', function () { scrollToCard(open ? active - 1 : 0); });
    if (next) next.addEventListener('click', function () { scrollToCard(open ? active + 1 : 0); });
    index.forEach(function (b, k) { b.addEventListener('click', function () { scrollToCard(k); }); });

    var tick = false;
    function onScroll() { if (!tick) { tick = true; requestAnimationFrame(function () { tick = false; update(); }); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    var onResize = function () { measure(); H = 0; open = null; onScroll(); };
    if (window.ResizeObserver) new ResizeObserver(onResize).observe(stage); else window.addEventListener('resize', onResize);
    measure();
    update();
  }

  /* ---------- Product: gallery, variants, quantity ---------- */
  function Product(root) {
    var main = root.querySelector('[data-main-img], .js-main-img');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    function show(src, srcset, alt, mediaId) {
      if (!main) return;
      main.srcset = srcset || ''; main.src = src; if (alt) main.alt = alt;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-id') === String(mediaId) ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        show(t.getAttribute('data-src'), t.getAttribute('data-srcset'), t.getAttribute('data-alt'), t.getAttribute('data-media-id'));
      });
    });

    var json = root.querySelector('[data-product-json]');
    var product = null;
    try { product = json ? JSON.parse(json.textContent) : null; } catch (e) {}
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]');
    var nameEls = root.querySelectorAll('[data-variant-name]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[name="id"][type="radio"]'));
    function money(cents) {
      var fmt = root.getAttribute('data-money-format') || '€{{amount_with_comma_separator}}';
      var v = (cents / 100).toFixed(2);
      var withComma = v.replace('.', ',');
      return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    function update(id) {
      if (!product) return;
      var v = null;
      for (var i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === String(id)) v = product.variants[i];
      if (!v) return;
      var poMatch = root.getAttribute('data-po-match');
      var isPo = !!(root.hasAttribute('data-po-all') || (poMatch && v.title.indexOf(poMatch) > -1));
      var shown = isPo ? Math.round(v.price * (parseInt(root.getAttribute('data-po-keep'), 10) || 100) / 100) : v.price;
      if (priceEl) priceEl.textContent = money(shown);
      document.querySelectorAll('[data-mbar-price]').forEach(function (el) { el.textContent = money(shown); });
      root.querySelectorAll('[data-po-only]').forEach(function (el) { el.hidden = !isPo; });
      root.querySelectorAll('[data-po-hide]').forEach(function (el) { el.hidden = isPo; });
      root.__po = isPo ? { id: v.id, unit: shown } : null;
      var poProp = root.querySelector('[data-po-prop]');
      if (poProp) poProp.disabled = !isPo;
      var poCta = root.getAttribute('data-po-cta');
      document.querySelectorAll('[data-mbar-btn]').forEach(function (el) { el.textContent = isPo ? poCta : el.getAttribute('data-default'); });
      document.querySelectorAll('.mbar [data-variant-name]').forEach(function (el) { el.textContent = v.title; });
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = !v.available ? addLabel.getAttribute('data-soldout') : (isPo ? poCta : addLabel.getAttribute('data-available'));
      Array.prototype.forEach.call(nameEls, function (el) { el.textContent = v.title; });
      if (v.featured_media && v.featured_media.preview_image) {
        var src = v.featured_media.preview_image.src;
        var sep = src.indexOf('?') > -1 ? '&' : '?';
        show(src + sep + 'width=1200', '', v.featured_media.alt || '', v.featured_media.id);
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) update(r.value); }); });
    var checked = root.querySelector('input[name="id"]:checked') || root.querySelector('input[name="id"][type="hidden"]');
    if (checked && (root.getAttribute('data-po-match') || root.hasAttribute('data-po-all'))) {
      var pv = null;
      if (product) for (var k = 0; k < product.variants.length; k++) if (String(product.variants[k].id) === String(checked.value)) pv = product.variants[k];
      if (pv && (root.hasAttribute('data-po-all') || pv.title.indexOf(root.getAttribute('data-po-match')) > -1)) root.__po = { id: pv.id, unit: Math.round(pv.price * (parseInt(root.getAttribute('data-po-keep'), 10) || 100) / 100) };
    }
    var pform = root.querySelector('#product-form, form[action*="/cart/add"]');
    if (pform) pform.addEventListener('submit', function (e) {
      if (!root.__po || !window.PreOrder) return;
      e.preventDefault();
      var q = root.querySelector('[data-qty]');
      window.PreOrder.open(root.__po.id, q ? Math.max(1, parseInt(q.value, 10) || 1) : 1, root.__po.unit, root.getAttribute('data-po-ship'));
    });

    var qty = root.querySelector('[data-qty]');
    if (qty) {
      var minus = root.querySelector('[data-qty-minus]'), plus = root.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1); });
    }
  }

  /* ---------- Scroll effects: parallax gallery + stacking cards ----------
     One passive scroll listener, work done at most once per frame, and only
     for sections that are on screen. Phones get direct (unsmoothed) mapping so
     movement follows the finger exactly. */
  var fx = { items: [], tick: false, touch: false };
  try { fx.touch = window.matchMedia('(hover: none)').matches; } catch (e) {}
  var clamp01 = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  function fxRun() {
    fx.tick = false;
    var more = false, vh = window.innerHeight;
    fx.items.forEach(function (it) {
      if (!it.visible) return;
      if (it.update(vh)) more = true;
    });
    if (more) fxKick();
  }
  function fxKick() { if (!fx.tick) { fx.tick = true; requestAnimationFrame(fxRun); } }
  function fxAdd(el, update) {
    var it = { el: el, update: update, visible: true };
    fx.items.push(it);
    if ('IntersectionObserver' in window) {
      it.visible = false;
      new IntersectionObserver(function (es) { es.forEach(function (en) { it.visible = en.isIntersecting; }); if (it.visible) fxKick(); }, { rootMargin: '200px 0px' }).observe(el);
    }
    fxKick();
  }
  window.addEventListener('scroll', fxKick, { passive: true });
  window.addEventListener('resize', fxKick);

  function Parallax(root) {
    if (reduced) return;
    var banner = root.querySelector('[data-px-banner]');
    var matrix = root.querySelector('[data-px-matrix]');
    var cols = Array.prototype.slice.call(root.querySelectorAll('[data-px-col]'));
    var lines = Array.prototype.slice.call(root.querySelectorAll('[data-px-line]'));
    var cur = null;
    var ys = [[0, -40], [-40, 10], [0, -40], [-30, 20]];
    var segs = [[0, 0.36], [0.36, 0.68], [0.68, 2]];
    fxAdd(root, function (vh) {
      var r = root.getBoundingClientRect(), span = r.height - vh;
      var p = span > 0 ? clamp01(-r.top / span) : 1;
      if (fx.touch || cur === null) cur = p; else cur += (p - cur) * 0.16;
      var c = cur, narrow = window.innerWidth < 900;
      var e = narrow ? 1 : clamp01(c / 0.15);
      banner.style.clipPath = e >= 1 ? 'none' : 'inset(' + ((1 - e) * 10) + '% ' + ((1 - e) * 5) + '% round ' + ((1 - e) * 40) + 'px)';
      var q = clamp01((c - 0.15) / 0.85), k = narrow ? 0.65 : 1;
      var L = function (a, b) { return a + (b - a) * q; };
      matrix.style.transform = 'translateZ(' + L(-800 * k, 0) + 'px) rotateX(' + L(25 * k, 4) + 'deg) rotateY(' + L(-45 * k, -8) + 'deg) rotateZ(' + L(15 * k, 2) + 'deg)';
      cols.forEach(function (col, i) { var y = ys[i % 4]; col.style.transform = 'translateY(' + L(y[0], y[1]) + '%)'; });
      lines.forEach(function (ln, i) {
        var s = segs[Math.min(i, 2)];
        var fin = i === 0 ? 1 : clamp01((c - s[0]) / 0.07), fout = i >= 2 ? 1 : clamp01((s[1] - c) / 0.07);
        var op = fin * fout;
        ln.style.opacity = String(op);
        ln.style.transform = 'translateY(' + ((1 - op) * 16) + 'px)';
        ln.style.pointerEvents = op > 0.5 ? 'auto' : 'none';
      });
      return Math.abs(p - c) > 0.0008;
    });
  }

  function Stack(root) {
    if (reduced) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-stack-card]'));
    var n = cards.length;
    if (!n) return;
    fxAdd(root, function (vh) {
      var r = root.getBoundingClientRect(), span = r.height - vh;
      var p = span > 0 ? clamp01(-r.top / span) : 0;
      var narrow = window.innerWidth < 900, step = narrow ? 0.03 : 0.05, from = narrow ? 1.15 : 1.35;
      cards.forEach(function (card, i) {
        var start = i / n, t = clamp01((p - start) / (1 - start));
        card.style.transform = 'scale(' + (1 - (n - i) * step * t) + ')';
        var img = card.querySelector('.js-stack-img'), slot = card.parentElement;
        if (img && slot) {
          var en = clamp01(1 - slot.getBoundingClientRect().top / vh);
          img.style.transform = 'scale(' + (from + (1 - from) * en) + ')';
        }
      });
      return false;
    });
  }

  /* ---------- Hero: two editions ---------- */
  function EditionHero(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ed]'));
    var peek = root.querySelector('[data-ed-peek]');
    var current = 'a', timer = null;
    var seconds = parseInt(root.getAttribute('data-interval'), 10) || 5;
    function set(ed) {
      if (ed === current) return;
      current = ed;
      root.classList.add('is-swapped');
      root.classList.toggle('is-a', ed === 'a');
      root.classList.toggle('is-b', ed === 'b');
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ed') === ed ? 'true' : 'false'); });
      if (peek) peek.setAttribute('aria-label', 'Покажи другото издание');
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    buttons.forEach(function (b) { b.addEventListener('click', function () { stop(); set(b.getAttribute('data-ed')); }); });
    if (peek) peek.addEventListener('click', function () { stop(); set(current === 'a' ? 'b' : 'a'); });
    /* Auto-switching starts only after the visitor's first scroll, tap or key press.
       Switching on a timer from page load made the browser (and PageSpeed) count the gold book
       as a new "largest element" at ~5 s, which pushed LCP from ~2 s to 5-6 s. */
    function startAuto() {
      if (reduced || timer) return;
      timer = setInterval(function () {
        if (document.hidden) return;
        var r = root.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return; // don't animate off-screen
        set(current === 'a' ? 'b' : 'a');
      }, seconds * 1000);
    }
    var kick = function () {
      ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (ev) { window.removeEventListener(ev, kick, true); });
      if (current === 'a' && !root.classList.contains('is-swapped')) startAuto();
    };
    ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (ev) { window.addEventListener(ev, kick, { capture: true, passive: true, once: false }); });
  }

  /* ---------- "Полъх от книгата" on phones: book opens on view, swipe carousel ---------- */
  function ReasonsMobile(rm) {
    var track = rm.querySelector('[data-rm-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-rm-card]'));
    var dots = Array.prototype.slice.call(rm.querySelectorAll('[data-rm-dots] button'));
    var prev = rm.querySelector('[data-rm-prev]'), next = rm.querySelector('[data-rm-next]');
    var cur = 0, n = cards.length, tick = false;
    function open() { rm.classList.add('is-open'); }
    if (reduced || !('IntersectionObserver' in window)) open();
    else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { open(); io.disconnect(); } });
      }, { threshold: 0.35 });
      io.observe(rm.querySelector('.rm-stage') || rm);
    }
    function mark(i) {
      cur = i;
      cards.forEach(function (c, k) { c.classList.toggle('is-center', k === i); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (prev) prev.classList.toggle('is-off', i === 0);
      if (next) next.classList.toggle('is-off', i === n - 1);
    }
    function go(i) {
      i = Math.max(0, Math.min(n - 1, i));
      var c = cards[i]; if (!c) return;
      track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: reduced ? 'auto' : 'smooth' });
      mark(i);
    }
    track.addEventListener('scroll', function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
        cards.forEach(function (c, k) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = k; } });
        if (best !== cur) mark(best);
      });
    }, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
  }

  /* ---------- Mobile order bar ----------
     Shows once the page's own order buttons ([data-mbar-anchor]) have scrolled off the top,
     hides from the final banner / footer ([data-mbar-stop]) and while the reasons section is pinned. */
  function MobileBar(bar) {
    var anchors = Array.prototype.slice.call(document.querySelectorAll('[data-mbar-anchor]'));
    var stops = Array.prototype.slice.call(document.querySelectorAll('[data-mbar-stop]'));
    var ww = document.querySelector('[data-reasons-wheel]');
    var on = null, tick = false;
    function check() {
      tick = false;
      var vh = window.innerHeight, show;
      if (anchors.length) show = anchors.every(function (a) { return a.getBoundingClientRect().bottom < 0; });
      else show = window.pageYOffset > vh * 0.6;
      if (show) stops.forEach(function (s) { if (s.getBoundingClientRect().top < vh) show = false; });
      if (show && ww) { var r = ww.getBoundingClientRect(); if (r.top <= 1 && r.bottom >= vh - 1) show = false; }
      if (show !== on) { on = show; bar.classList.toggle('is-on', show); }
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ---------- Hero video: desktop by default; never with reduced motion / data saver; pauses off screen ---------- */
  function HeroVideo(v) {
    var saveData = false;
    try { saveData = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}
    var mobileOk = v.getAttribute('data-mobile') === '1';
    if (mobileOk) v.classList.add('is-mobile-ok');
    if (reduced || saveData || (window.innerWidth < 900 && !mobileOk)) return;
    v.muted = true; v.defaultMuted = true; v.playsInline = true; v.preload = 'auto';
    var play = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) play(); else v.pause(); }); }).observe(v);
    } else play();
  }

  /* ---------- Pre-order explainer → straight to checkout ---------- */
  function PreOrderModal(dlg) {
    var cur = null, opener = null;
    var go = dlg.querySelector('[data-po-go]'), goLabel = go ? go.querySelector('span') : null;
    var err = dlg.querySelector('[data-po-err]'), totalEl = dlg.querySelector('[data-po-total]');
    var fmt = dlg.getAttribute('data-money-format') || '€{{amount_with_comma_separator}}';
    function money(c) { var v = (c / 100).toFixed(2); return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)); }
    function open(id, qty, unit, ship) {
      cur = { id: id, qty: qty || 1, ship: ship || dlg.getAttribute('data-default-date') || '' };
      dlg.querySelectorAll('[data-po-date]').forEach(function (el) { el.textContent = cur.ship; });
      opener = document.activeElement;
      if (totalEl && unit) totalEl.textContent = money(unit * cur.qty);
      if (err) err.hidden = true;
      if (go) { go.disabled = false; if (goLabel) goLabel.textContent = goLabel.__t || (goLabel.__t = goLabel.textContent); }
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('po-lock');
    }
    function close() {
      if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
    }
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('po-lock'); if (opener && opener.focus) opener.focus(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.querySelectorAll('[data-po-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (go) go.addEventListener('click', function () {
      if (!cur) return;
      go.disabled = true; if (goLabel) { goLabel.__t = goLabel.__t || goLabel.textContent; goLabel.textContent = go.getAttribute('data-wait'); }
      var props = {}; props[dlg.getAttribute('data-prop-name')] = cur.ship ? 'Изпращане ' + cur.ship : dlg.getAttribute('data-prop-value');
      fetch(dlg.getAttribute('data-add-url'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(cur.id), quantity: cur.qty, properties: props }] })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); window.location.href = dlg.getAttribute('data-checkout-url'); })
        .catch(function () { go.disabled = false; if (goLabel) goLabel.textContent = goLabel.__t; if (err) err.hidden = false; });
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-po-open]');
      if (!a) return;
      e.preventDefault();
      open(a.getAttribute('data-po-variant'), 1, parseInt(a.getAttribute('data-po-unit'), 10) || 0, a.getAttribute('data-po-ship'));
    });
    window.PreOrder = { open: open, close: close };
  }

  /* ---------- "Which edition?" window for general Поръчай buttons ---------- */
  function EditionPicker(dlg) {
    var opener = null;
    function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('po-lock'); if (opener && opener.focus) opener.focus(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.querySelectorAll('[data-ep-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-ed-pick]');
      if (!a) return;
      e.preventDefault();
      opener = a;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('po-lock');
    });
  }

  /* ---------- Testimonials slider ---------- */
  function Testimonials(head) {
    var sec = head.parentNode, track = sec.querySelector('[data-tq-track]'), nav = head.querySelector('[data-tq-nav]');
    if (!track || !nav) return;
    var prev = nav.querySelector('[data-tq-prev]'), next = nav.querySelector('[data-tq-next]');
    function step() { var c = track.querySelector('.tq-card'); return c ? c.getBoundingClientRect().width + 24 : track.clientWidth * 0.8; }
    function sync() {
      var over = track.scrollWidth > track.clientWidth + 4;
      nav.hidden = !over;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------- Smart sticky header ---------- */
  function SmartHeader(h) {
    var last = window.scrollY, ticking = false, drawer = h.querySelector('.menu-drawer'), reasons = document.getElementById('reasons');
    function inPinned() { if (!reasons) return false; var r = reasons.getBoundingClientRect(); return r.top <= 0 && r.bottom >= window.innerHeight; }
    function update() {
      ticking = false;
      var y = window.scrollY, open = drawer && drawer.open;
      h.classList.toggle('is-stuck', y > 40);
      if (open || y < 120) h.classList.remove('is-hidden');
      else if (inPinned()) h.classList.add('is-hidden');
      else if (y > last + 6) h.classList.add('is-hidden');
      else if (y < last - 6) h.classList.remove('is-hidden');
      if (Math.abs(y - last) > 6) last = y;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
    if (drawer) {
      drawer.addEventListener('click', function (e) { if (e.target.closest('a')) drawer.open = false; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer.open = false; });
      document.addEventListener('click', function (e) { if (drawer.open && !drawer.contains(e.target)) drawer.open = false; });
    }
    update();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-hero-video]').forEach(function (v) { if (!v.__hv) { v.__hv = true; HeroVideo(v); } });
    if (!scope) { var sh = document.querySelector('[data-smart-header]'); if (sh && !sh.__sh) { sh.__sh = true; SmartHeader(sh); } }
    (scope || document).querySelectorAll('[data-tq]').forEach(function (h) { if (!h.__tq) { h.__tq = true; Testimonials(h); } });
    if (!scope) { var pom = document.querySelector('[data-po-modal]'); if (pom && !pom.__po) { pom.__po = true; PreOrderModal(pom); } }
    if (!scope) { var epm = document.querySelector('[data-ed-modal]'); if (epm && !epm.__ep) { epm.__ep = true; EditionPicker(epm); } }
    if (!scope) { var mb = document.querySelector('[data-mbar]'); if (mb && !mb.__mb) { mb.__mb = true; MobileBar(mb); } }
    (scope || document).querySelectorAll('[data-parallax]').forEach(function (el) { if (!el.__px) { el.__px = true; Parallax(el); } });
    (scope || document).querySelectorAll('[data-stack]').forEach(function (el) { if (!el.__st) { el.__st = true; Stack(el); } });
    (scope || document).querySelectorAll('[data-edition-hero]').forEach(function (el) { if (!el.__ed) { el.__ed = true; EditionHero(el); } });
    (scope || document).querySelectorAll('[data-reasons-wheel]').forEach(function (el) { if (!el.__ww) { el.__ww = true; Wheel(el); } });
    (scope || document).querySelectorAll('[data-rm]').forEach(function (el) { if (!el.__rm) { el.__rm = true; ReasonsMobile(el); } });
    (scope || document).querySelectorAll('[data-product-root]').forEach(function (el) { if (!el.__pr) { el.__pr = true; Product(el); } });
  }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();